<div class="circuit-table" [class.circuit-table--minified]="isMinified">
  <div *ngIf="showCubicleName && !isSubCircuit && circuit.no as cubicleNo" class="circuit-table__name" [class.circuit-table__name--clickable]="entityIsClickable(circuit)">
    <a *ngIf="routeForEntity(circuit) as cubicleRoute; else cubicleLabel" [routerLink]="cubicleRoute" [queryParams]="tagQueryParams(cubicleNo)" aria-label="Cubicle element">{{ displayLabel(cubicleNo) }}</a>
    <ng-template #cubicleLabel>{{ displayLabel(cubicleNo) }}</ng-template>
    <button
      type="button"
      class="circuit-table__focus-button"
      (click)="requestCircuitFocus($event)"
      aria-label="Focus cubicle circuit"
    >
      <span aria-hidden="true">⌕</span>
    </button>
    <ng-container *ngIf="circuit.checkSheetStatuses?.length; else cubicleDefaultStatus">
      <div class="circuit-table__status-indicators">
        <app-check-sheet-status
          *ngFor="let checkSheetStatus of circuit.checkSheetStatuses"
          class="circuit-table__status-indicator"
          [status]="checkSheetStatus.status?.name"
          [label]="checkSheetStatus.name"
        />
      </div>
    </ng-container>
    <ng-template #cubicleDefaultStatus>
      <div class="circuit-table__status-indicators">
        <app-status-circle class="circuit-table__status-indicator circuit-table__status-indicator--default" [status]="cubicleStatusName(circuit)" />
      </div>
    </ng-template>
  </div>

  <div class="circuit-table__tags" [style.margin]="isSubCircuit ? '0 0 1em 0' : '1em 0'">
    <div
      class="circuit-table__tag"
      [class.circuit-table__tag--cable]="tag.kind === 'CABLE_HEAT_TRACE' || tag.kind === 'CABLE_OTHER'"
      [class.circuit-table__tag--branch]="tag.kind === 'JUNCTION_BOX'"
      *ngFor="let tag of circuit.tags; let i = index"
    >

      <!-- Cable -->
      <ng-container *ngIf="tag.kind === 'CABLE_HEAT_TRACE' || tag.kind === 'CABLE_OTHER'">
        <div class="circuit-table__cable-wrapper">
          <a *ngIf="routeForEntity(tag) as cableRoute; else cableLabel" class="circuit-table__cable-link circuit-table__cable-link--clickable" [routerLink]="cableRoute" [queryParams]="tagQueryParams(tag.no)" aria-label="Heat trace element">
            <div
              class="circuit-table__cable circuit-table__cable--{{ tag.kind }}"
              [class.circuit-table__cable--external]="tag.kind === 'CABLE_HEAT_TRACE' && !!tag.isExternal"
            >
              {{ displayLabel(tag.no, previousLabelForIndex(i)) }}
              <div
                *ngIf="tag.kind == 'CABLE_HEAT_TRACE'"
                class="CABLE_HEAT_TRACE"
                [class.CABLE_HEAT_TRACE--external]="!!tag.isExternal"
              >
              </div>
            </div>
            <ng-container *ngIf="tag.checkSheetStatuses?.length; else cableDefaultStatus">
              <div class="circuit-table__status-indicators">
                <app-check-sheet-status
                  *ngFor="let checkSheetStatus of tag.checkSheetStatuses"
                  class="circuit-table__status-indicator"
                  [status]="checkSheetStatus.status?.name"
                  [label]="checkSheetStatus.name"
                />
              </div>
            </ng-container>
            <ng-template #cableDefaultStatus>
              <div class="circuit-table__status-indicators">
                <app-status-circle class="circuit-table__status-indicator circuit-table__status-indicator--default" [status]="tag.status?.name" />
              </div>
            </ng-template>
          </a>
          <ng-template #cableLabel>
            <div class="circuit-table__cable-link">
              <div
                class="circuit-table__cable circuit-table__cable--{{ tag.kind }}"
                [class.circuit-table__cable--external]="tag.kind === 'CABLE_HEAT_TRACE' && !!tag.isExternal"
              >
                {{ displayLabel(tag.no, previousLabelForIndex(i)) }}
                <div
                  *ngIf="tag.kind == 'CABLE_HEAT_TRACE'"
                  class="heat-trace"
                  [class.heat-trace--external]="!!tag.isExternal"
                >
                </div>
              </div>
              <ng-container *ngIf="tag.checkSheetStatuses?.length; else cableStaticDefaultStatus">
                <div class="circuit-table__status-indicators">
                  <app-check-sheet-status
                    *ngFor="let checkSheetStatus of tag.checkSheetStatuses"
                    class="circuit-table__status-indicator"
                    [status]="checkSheetStatus.status?.name"
                    [label]="checkSheetStatus.name"
                  />
                </div>
              </ng-container>
              <ng-template #cableStaticDefaultStatus>
                <div class="circuit-table__status-indicators">
                  <app-status-circle class="circuit-table__status-indicator circuit-table__status-indicator--default" [status]="tag.status?.name" />
                </div>
              </ng-template>
            </div>
          </ng-template>
         </div>
       </ng-container>

       <!-- Jbox without sub-circuits -->
       <ng-container *ngIf="tag.kind === 'JUNCTION_BOX' && !tag.circuits.length">
         <div class="circuit-table__jbox" [class.circuit-table__jbox--clickable]="entityIsClickable(tag)">
          <a *ngIf="routeForEntity(tag) as jboxRoute; else jboxLabel" [routerLink]="jboxRoute" [queryParams]="tagQueryParams(tag.no)" aria-label="Junction box element">{{ displayLabel(tag.no, previousLabelForIndex(i)) }}</a>
          <ng-template #jboxLabel>{{ displayLabel(tag.no, previousLabelForIndex(i)) }}</ng-template>
           <ng-container *ngIf="tag.checkSheetStatuses?.length; else jboxDefaultStatus">
             <div class="circuit-table__status-indicators">
               <app-check-sheet-status
                 *ngFor="let checkSheetStatus of tag.checkSheetStatuses"
                 class="circuit-table__status-indicator"
                 [status]="checkSheetStatus.status?.name"
                 [label]="checkSheetStatus.name"
               />
             </div>
           </ng-container>
           <ng-template #jboxDefaultStatus>
             <div class="circuit-table__status-indicators">
               <app-status-circle class="circuit-table__status-indicator circuit-table__status-indicator--default" [status]="tag.status?.name" />
             </div>
           </ng-template>
         </div>
       </ng-container>

       <!-- Terminal -->
       <ng-container *ngIf="tag.kind === 'TERMINAL_TAG'">
         <div class="circuit-table__terminal" [class.circuit-table__terminal--clickable]="entityIsClickable(tag)">
          <a *ngIf="routeForEntity(tag) as terminalRoute; else terminalLabel" [routerLink]="terminalRoute" [queryParams]="tagQueryParams(tag.no)" aria-label="Terminal element">{{ displayLabel(tag.no, previousLabelForIndex(i)) }}</a>
          <ng-template #terminalLabel>{{ displayLabel(tag.no, previousLabelForIndex(i)) }}</ng-template>
           <div class="circuit-table__status-indicators">
             <app-status-circle class="circuit-table__status-indicator circuit-table__status-indicator--default" [status]="tag.status?.name" />
           </div>
         </div>
       </ng-container>

       <!-- Jbox with sub-circuits → recurse -->
       <ng-container *ngIf="tag.kind === 'JUNCTION_BOX' && tag.circuits.length">
         <div class="circuit-table__branch">
           <div class="circuit-table__jbox" [class.circuit-table__jbox--clickable]="entityIsClickable(tag)">
            <a *ngIf="routeForEntity(tag) as branchJboxRoute; else branchJboxLabel" [routerLink]="branchJboxRoute" [queryParams]="tagQueryParams(tag.no)" aria-label="Junction box element">{{ displayLabel(tag.no, previousLabelForIndex(i)) }}</a>
            <ng-template #branchJboxLabel>{{ displayLabel(tag.no, previousLabelForIndex(i)) }}</ng-template>
             <ng-container *ngIf="tag.checkSheetStatuses?.length; else branchJboxDefaultStatus">
               <div class="circuit-table__status-indicators">
                 <app-check-sheet-status
                   *ngFor="let checkSheetStatus of tag.checkSheetStatuses"
                   class="circuit-table__status-indicator"
                   [status]="checkSheetStatus.status?.name"
                   [label]="checkSheetStatus.name"
                 />
               </div>
             </ng-container>
             <ng-template #branchJboxDefaultStatus>
               <div class="circuit-table__status-indicators">
                 <app-status-circle class="circuit-table__status-indicator circuit-table__status-indicator--default" [status]="tag.status?.name" />
               </div>
             </ng-template>
             <button
               type="button"
               class="circuit-table__focus-button"
               (click)="requestFocus(tag.no, $event)"
               aria-label="Zoom into branch"
             >
               <span aria-hidden="true">⌕</span>
             </button>
           </div>
           <div class="circuit-table__branch-circuits">
             <app-circuit-table
               *ngFor="let sub of tag.circuits"
               [circuit]="sub"
               [isSubCircuit]="true"
               [showCubicleName]="showCubicleName"
               [pathPrefix]="extendPath(pathPrefix, tag.no)"
               [focusPath]="focusPath"
               [isMinified]="isMinified"
               (focusRequested)="focusRequested.emit($event)"
             ></app-circuit-table>
           </div>
         </div>
       </ng-container>

    </div>
  </div>
</div>
